import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { c as C } from "../index-C3-ZVs5E.js";
import { useState as U, useMemo as j, useCallback as r } from "react";
import { Button as s } from "../shared/button/Button.component.js";
import { ButtonShapeEnum as d, ButtonSizeEnum as c, ButtonThemeEnum as h } from "../shared/button/types.js";
import { LoadingView as V } from "../shared/loading-view/LoadingView.component.js";
import { defaultCopies as z } from "./default-copies.js";
import { EmptyFilesState as B } from "./EmptyFilesState.component.js";
import { FileListItem as F } from "./FileListItem.component.js";
import { FileUploadWidget as I } from "./FileUploadWidget.component.js";
import { FileWidgetItem as R } from "./FileWidgetItem.component.js";
import { GridIcon as A } from "./icons/Grid.icon.js";
import { ListIcon as G } from "./icons/List.icon.js";
import { getFileTypeFromMime as O } from "./utils.js";
const oe = ({
  copies: p = z,
  files: u = [],
  hasMoreItems: E,
  isLoading: w,
  isUploading: b,
  fileError: L,
  onFilesDropped: S,
  onDeleteEntries: x,
  onLoadMore: M
}) => {
  const [i, f] = U("grid"), a = j(() => u.map((e) => ({
    ...e,
    type: O(e.mimeType)
  })), [u]), T = r(() => {
    f("list");
  }, []), D = r(() => {
    f("grid");
  }, []), y = r((e) => {
    window.open(e.url, "_blank", "noopener,noreferrer");
  }, []), g = r(async (e) => {
    try {
      await navigator.clipboard.writeText(e.url);
    } catch (n) {
      console.error("Copy failed", n);
    }
  }, []), k = r(async (e) => {
    try {
      const n = await fetch(e.url, {
        mode: "cors"
      });
      if (!n.ok)
        throw new Error(`HTTP error! Status: ${n.status}`);
      const o = await n.blob(), v = window.URL.createObjectURL(o), l = document.createElement("a");
      l.href = v, l.download = e.name ?? "download", document.body.appendChild(l), l.click(), document.body.removeChild(l), window.URL.revokeObjectURL(v);
    } catch {
      const o = document.createElement("a");
      o.href = e.url, o.setAttribute("download", e.name ?? "download"), o.setAttribute("rel", "noopener noreferrer"), o.setAttribute("target", "_blank"), document.body.appendChild(o), o.click(), document.body.removeChild(o);
    }
  }, []), N = r(
    (e) => {
      x([{ id: e.id }]);
    },
    [x]
  );
  return /* @__PURE__ */ t("main", { className: "app:text-stone-950 app:w-full app:overflow-auto", children: /* @__PURE__ */ t("div", { className: "app:md:w-3xl app:xl:w-6xl app:w-full app:mx-auto app:flex app:flex-col app:overflow-hidden app:mb-30", children: /* @__PURE__ */ m("div", { className: "app:p-4", children: [
    /* @__PURE__ */ t(
      I,
      {
        copies: p,
        onDrop: S,
        isLoading: b,
        disabled: b,
        hasError: !!L
      }
    ),
    /* @__PURE__ */ m("div", { className: "app:flex app:items-center app:justify-between app:mb-6", children: [
      /* @__PURE__ */ t("h1", { className: "app:text-2xl app:font-semibold", children: p.fileExplorer.fileSectionTitle }),
      /* @__PURE__ */ m("div", { className: "app:flex app:items-center app:gap-1", children: [
        /* @__PURE__ */ t(
          s,
          {
            type: "button",
            className: C(
              "app:[--button--padding--sm:8px] app:[--button--min-width--sm:0px]",
              i === "grid" ? "app:text-stone-e00" : "app:text-stone-950"
            ),
            theme: h.naked,
            size: c.sm,
            shape: d.pill,
            onClick: D,
            children: /* @__PURE__ */ t(A, { className: "app:w-4 app:h-4" })
          }
        ),
        /* @__PURE__ */ t(
          s,
          {
            type: "button",
            className: C(
              "app:[--button--padding--sm:8px] app:[--button--min-width--sm:0px]",
              i === "list" ? "app:text-stone-e00" : "app:text-stone-950"
            ),
            theme: h.naked,
            size: c.sm,
            shape: d.pill,
            onClick: T,
            children: /* @__PURE__ */ t(G, { className: "app:w-4 app:h-4" })
          }
        )
      ] })
    ] }),
    !w && a.length === 0 ? /* @__PURE__ */ t(B, { copies: p }) : i === "list" ? /* @__PURE__ */ t("div", { className: "app:flex app:flex-col app:gap-2", children: a == null ? void 0 : a.map((e) => /* @__PURE__ */ t(
      F,
      {
        file: e,
        copies: p,
        onDeleteEntry: N,
        onCopy: g,
        onDownload: k,
        onView: y
      },
      e.id
    )) }) : /* @__PURE__ */ t("div", { className: "app:grid app:grid-cols-1 app:sm:grid-cols-2 app:md:grid-cols-3 app:xl:grid-cols-4 app:gap-4", children: a == null ? void 0 : a.map((e) => /* @__PURE__ */ t(
      R,
      {
        file: e,
        copies: p,
        onDeleteEntry: N,
        onCopy: g,
        onDownload: k,
        onView: y
      },
      e.id
    )) }),
    w ? /* @__PURE__ */ t("div", { className: "app:my-10", children: /* @__PURE__ */ t(V, {}) }) : a.length > 0 && E ? /* @__PURE__ */ t(
      s,
      {
        type: "button",
        className: "app:my-10 app:[--button--padding:0px] app:[--button--min-width--sm:0px] app:mx-auto",
        theme: h.outline,
        size: c.sm,
        shape: d.pill,
        onClick: M,
        children: p.fileExplorer.loadMore
      }
    ) : null
  ] }) }) });
};
export {
  oe as FileExplorer
};
